/**
 * Angular imports
 */
import {Component, provide} from 'angular2/core';
import {RouteConfig} from "angular2/router";
import {HTTP_PROVIDERS, Http, XHRBackend, BrowserXhr, BaseRequestOptions} from 'angular2/http';

/**
 * Configuration imports
 */
import {CustomHttp} from './http/custom_http';
import {CustomBrowserXhr} from './http/custom_browser_xhr';
import {CustomBaseRequestOptions} from './http/custom_base_request_options';
import {Routes} from "./routes";

/**
 * Node modules imports
 */
import {TranslateLoader, TranslateStaticLoader, TranslateService} from 'ng2-translate';
import 'rxjs/Rx';

/**
 * Component imports
 */
import {NavbarComponent} from "./components/layout/navbar/navbar.component";
import {FooterComponent} from "./components/layout/footer/footer.component";
import {AlertsComponent} from "./components/common/alerts/alerts.component";

/**
 * Service imports
 */
import {AlertService} from "./components/common/alerts/alert.service";
import {KeycloakService} from "./http/keycloak.service";

@Component({
    selector: 'voucher-app',
    template: `
        <navbar></navbar>
         <div class="container-fluid">
            <div class="content">
                <alerts></alerts>
                <router-outlet></router-outlet>
            </div>
        </div>
        <footer></footer>
    `,
    directives: [NavbarComponent, FooterComponent, AlertsComponent],
    providers: [HTTP_PROVIDERS,
        provide(BrowserXhr, {useClass: CustomBrowserXhr}),
        provide(BaseRequestOptions, {useClass: CustomBaseRequestOptions}),
        provide(Http, {useClass: CustomHttp, deps: [XHRBackend, BaseRequestOptions, KeycloakService]}),
        provide(TranslateLoader, {
            useFactory: function (http: Http) {
                return new TranslateStaticLoader(http, 'assets/locales', '.json');
            },
            deps: [Http]
        }),
        TranslateService,
        AlertService,
        KeycloakService
    ]

})

@RouteConfig(Routes.configure())

export class AppComponent {

    /**
     * @constructor
     * @param {TranslateService} _translate
     */
    constructor(private _translate: TranslateService) {
        var userLang = window.localStorage.getItem("locale"); // use navigator lang if available
        if (userLang === undefined || userLang === null) {
            userLang = 'fr';
            window.localStorage.setItem("locale", userLang);
        }

        // this language will be used as a fallback when a translation isn't found in the current language
        this._translate.setDefaultLang('fr');

        // the lang to use, if the lang isn't available, it will use the current loader to get them
        this._translate.use(userLang);
    }

}
